function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#DFBAFB",
  cx: 100,
  cy: 100,
  r: 100
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 60.334,
  y: 35,
  fill: "#FFEDEE",
  width: 93.332,
  height: 120
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 60.334,
  y: 35,
  fill: "#D5007F",
  width: 93.332,
  height: 16.002
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 71,
  y: 62.078,
  fill: "#9B4B4E",
  width: 72,
  height: 8.002
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 71,
  y: 80.746,
  fill: "#9B4B4E",
  width: 72,
  height: 8.002
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 71,
  y: 99.412,
  fill: "#9B4B4E",
  width: 72,
  height: 8.002
});

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#DADADA",
  d: "M37,124.305v49.848c0,2.117,1.729,3.848,3.848,3.848h92.305c2.117,0,3.848-1.73,3.848-3.848v-49.848 c0,0-23.877,7.695-50,7.695S37,124.305,37,124.305z"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#6D6D6D",
  d: "M133.152,112.77H40.848c-2.119,0-3.848,1.73-3.848,3.848v7.688c0,0,23.877,7.695,50,7.695s50-7.695,50-7.695 v-7.688C137,114.5,135.27,112.77,133.152,112.77z"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 46.617,
  y: 138.693,
  fill: "#FFFFFF",
  width: 19.23,
  height: 26.924
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 75.457,
  y: 137.77,
  fill: "#494949",
  width: 53.848,
  height: 5.771
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 75.457,
  y: 149.305,
  fill: "#494949",
  width: 38.467,
  height: 5.771
});

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 110.076,
  y: 160.848,
  fill: "#494949",
  width: 19.229,
  height: 5.77
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 75.457,
  y: 160.848,
  fill: "#494949",
  width: 19.236,
  height: 5.77
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  fill: "#00CAE1",
  cx: 30,
  cy: 170,
  r: 30
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "25.77,184.756 12,171.445 16.984,166.303 25.4,174.439 42.668,155.244 48,160.041 "
});

var SvgSolVerificadaImg = function SvgSolVerificadaImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSolVerificadaImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/solVerificada_img.0646fea0.svg";
export { ForwardRef as ReactComponent };